import Image from 'next/image'
import React, { useEffect, useState } from 'react'

import BackDrop from '@/shared/components/BackDrop'
import Button from '@/shared/components/button/Button'
import { Text } from '@/shared/components/typography'
import useOutsideClick from '@/shared/hooks/useOutsideClick'

type BottomSheetProps = {
  isOpen: boolean
  pxValue?: string
  ptValue?: string
  title?: React.ReactNode
  topTitle?: React.ReactNode
  bodyContent?: React.ReactNode
  disabled?: boolean
  btnText?: string
  secondBtnText?: string
  size?: string
  pyValue?: string
  className?: React.ComponentProps<'div'>['className']
  onClick: () => void
  onSecondClick?: () => void
  onClose?: () => void
  imgSrc?: {
    src: HTMLImageElement['src']
    alt: HTMLImageElement['alt']
    width: HTMLImageElement['width']
    height: HTMLImageElement['height']
  }
  imgStyleClass?: React.HTMLAttributes<HTMLImageElement>['className'] // NOTE: 이미지에 대한 스타일 커스터마이징 목적 (margin, padding 등)
}

const BottomSheet = ({
  isOpen,
  pxValue = 'px-4',
  ptValue = 'pt-10',
  title,
  topTitle,
  bodyContent,
  disabled,
  btnText,
  secondBtnText,
  size,
  pyValue,
  className,
  onClick,
  onSecondClick,
  onClose,
  imgSrc,
  imgStyleClass = 'pb-4'
}: BottomSheetProps) => {
  const ref = useOutsideClick(onClose || onClick)
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (isOpen && ref.current) setShow(true)
    else setShow(false)
  }, [isOpen, ref])

  if (!isOpen) {
    return null
  }

  return (
    <div>
      <BackDrop isOpen={isOpen} />
      <div ref={ref} className={`bottom-sheet-container ${pxValue} ${ptValue} ${show && 'bottom-sheet-show'}`}>
        <div className={`bottom-sheet-content`}>
          {topTitle && (
            <Text level="text1" color="text090" weight="bold">
              {topTitle}
            </Text>
          )}
          {imgSrc && (
            <Image
              src={imgSrc.src}
              alt={imgSrc.alt}
              width={imgSrc.width}
              height={imgSrc.height}
              className={imgStyleClass}
            />
          )}
          <Text level="text1" color="text090" weight="bold">
            {title}
          </Text>
          {bodyContent}
        </div>
        <div className="flex gap-2">
          {secondBtnText && onSecondClick && (
            <Button
              pyValue={pyValue}
              className={className}
              disabled={disabled}
              text={secondBtnText}
              background="bg020"
              color="text090"
              size={size}
              onClick={onSecondClick}
            />
          )}
          <Button disabled={disabled} text={btnText} background="bg030" color="text010" onClick={onClick} />
        </div>
      </div>
    </div>
  )
}

export default BottomSheet
